import { useEffect, useContext } from 'react';
import { useVoiceVisualizer, VoiceVisualizer } from 'react-voice-visualizer';
import ThemeContext from '../contexts/ThemeContext';
import styled from 'styled-components';
import Icon from './Icon';

const MicrophoneArea = styled.div`
  background-color: ${({ backgroundColor }) => backgroundColor};
  position: relative;
  width: 100%;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ControlsWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 700px;
  justify-content: space-between;
`;

const MicrophoneButton = styled.button`
  background-color: ${({ backgroundColor }) => backgroundColor};
  padding: 16px;
  border-radius: 50%;
  font-size: 1.5em;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledIcon = styled(Icon)`
  & > i, & > span {
    color: ${({ color }) => color} !important;
  }
`;

const VisualizerContainer = styled.div`
  flex: 1;
  margin: 0 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
`;

const VoiceVisualizerView = ({ onStartRecording, onStopRecording, onResumedRecording, onPausedRecording, onAudioStreamAvailable, onRecordingComplete, isRecording }) => {
  // callbacks
  const recorderControls = useVoiceVisualizer({
    onStartRecording,
    onStopRecording,
    onResumedRecording,
    onPausedRecording,
  });

  const { recordedBlob, error, startRecording, stopRecording, isRecordingInProgress, mediaRecorder } = recorderControls;
  const { colors } = useContext(ThemeContext);

  // Extract audio stream from react-voice-visualizer when recording starts
  useEffect(() => {
    if (isRecordingInProgress && mediaRecorder && mediaRecorder.stream) {
      // Pass the stream to parent component
      if (onAudioStreamAvailable) {
        onAudioStreamAvailable(mediaRecorder.stream);
      }
    }
  }, [isRecordingInProgress, mediaRecorder, onAudioStreamAvailable]);

  useEffect(() => {
    if (recordedBlob && onRecordingComplete) {
      onRecordingComplete(recordedBlob);
    }
  }, [recordedBlob, onRecordingComplete]);

  useEffect(() => {
    if (error) console.error(error);
  }, [error]);

  return (
    <MicrophoneArea backgroundColor={colors.backgroundColorAi}>
      {!isRecording ? (
        <MicrophoneButton
          backgroundColor={colors.tulkaMainColor}
          onClick={() => {
            startRecording();
          }}
        >
          <StyledIcon
            color={colors.webTextColor}
            iconLib="material"
            icon="mic"
          />
        </MicrophoneButton>
      ) : (
        <ControlsWrapper>
          <MicrophoneButton
            backgroundColor={colors.tulkaMainColor}
            onClick={() => {
              onStopRecording(true);
              stopRecording();
            }}
          >
            <StyledIcon
              color={colors.webTextColor}
              iconLib="material"
              icon="close"
            />
          </MicrophoneButton>

          <VisualizerContainer>
            <VoiceVisualizer
              controls={recorderControls}
              mainBarColor={colors.tulkaMainColor}
              backgroundColor="transparent"
              width={300}
              height={100}
              fullscreen={false}
              onlyRecording={false}
              isControlPanelShown={false}
              isDownloadAudioButtonShown={false}
              animateCurrentPick={false}
              isDefaultUIShown={false}
              mainContainerClassName={'myMainContainer'}
              canvasContainerClassName={'myCanvasContainer'}
              controlButtonsClassName={'myControlButtons'}
            />
          </VisualizerContainer>

          <MicrophoneButton
            backgroundColor={colors.tulkaMainColor}
            onClick={() => {
              stopRecording();
            }}
          >
            <StyledIcon
              color={colors.webTextColor}
              iconLib="material"
              icon="arrow_upward"
            />
          </MicrophoneButton>
        </ControlsWrapper>
      )}
    </MicrophoneArea>
  );
};

export default VoiceVisualizerView;
